import { get, post, put } from './apiClient';

// Serviço de autenticação
export const authService = {
  // Fazer login
  async login(email, password) {
    // Usar URLSearchParams para enviar dados como form-urlencoded
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);

    const response = await post('/api/v1/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    return response;
  },

  // Renovar token
  async refreshToken(refreshToken) {
    const response = await post('/api/v1/auth/refresh', {
      refresh_token: refreshToken,
    });

    return response;
  },

  // Obter usuário atual
  async getCurrentUser() {
    const response = await get('/api/v1/auth/me');
    return response;
  },

  // Atualizar usuário atual
  async updateCurrentUser(userData) {
    const response = await put('/api/v1/auth/me', userData);
    return response;
  },

  // Alterar senha
  async changePassword(currentPassword, newPassword) {
    const response = await post('/api/v1/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });

    return response;
  },

  // Criar novo usuário (apenas admin)
  async createUser(userData) {
    const response = await post('/api/v1/auth/register', userData);
    return response;
  },

  // Verificar se usuário está autenticado
  isAuthenticated() {
    const token = localStorage.getItem('token');
    return !!token;
  },

  // Obter token atual
  getToken() {
    return localStorage.getItem('token');
  },

  // Obter refresh token atual
  getRefreshToken() {
    return localStorage.getItem('refreshToken');
  },

  // Fazer logout (limpar tokens)
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  },
};
